module.exports = __webpack_public_path__ + "static/media/landing_bg.fa88eaf3.jpg";